export enum FactureExterneStatutEnum {
  A_TRAITER = 'A_TRAITER',
  VALIDEE_AUTOMATIQUEMENT = 'VALIDEE_AUTOMATIQUEMENT',
  VALIDEE_MANUELLEMENT = 'VALIDEE_MANUELLEMENT',
  REFUSEE = 'REFUSEE',
  ABANDONNEE = 'ABANDONNEE',
  EXPORTE = 'EXPORTE',
  EXPORT_CEGID = 'EXPORT_CEGID'
}

export const FACTURE_EXTERNE_STATUT_LABELS: Record<FactureExterneStatutEnum, string> = {
  [FactureExterneStatutEnum.A_TRAITER]:               'À traiter',
  [FactureExterneStatutEnum.VALIDEE_AUTOMATIQUEMENT]: 'Validée automatiquement',
  [FactureExterneStatutEnum.VALIDEE_MANUELLEMENT]:    'Validée manuellement',
  [FactureExterneStatutEnum.REFUSEE]:                 'Refusée',
  [FactureExterneStatutEnum.ABANDONNEE]:              'Abandonnée',
  [FactureExterneStatutEnum.EXPORTE]:                 'Exporté',
  [FactureExterneStatutEnum.EXPORT_CEGID]:            'Exporté Cegid',
};
